export default class ProductTag {
    name: string = "";
    backgroundColor: string = "";
    textColor: string = "";

    static fetchProductTagFromJson(productTag: any) : ProductTag {
        var tag = {} as ProductTag;

        tag.name = productTag.name;

        if(typeof productTag.backgroundColor != "undefined" && productTag.backgroundColor != null)
            tag.backgroundColor = productTag.backgroundColor.toUpperCase().replace("0XFF", "#");

        if(typeof productTag.textColor != "undefined" && productTag.textColor != null)
            tag.textColor = productTag.textColor.toUpperCase().replace("0XFF", "#");

        return tag;
    }
}